import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ConfirmationDialogComponent} from './confirmation-dialog.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
  declarations: [ConfirmationDialogComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    TranslateModule.forChild()
  ],
  exports: [ConfirmationDialogComponent]
})
export class ConfirmationDialogModule { }
